import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const REVIEWER_SCHEMA = Object.freeze({
  CLIENT_ID: '',
  NAME: '',
});
const RECORD = generateSchema(REVIEWER_SCHEMA);
const KEYS: any = generateKeys(REVIEWER_SCHEMA);

export class Reviewer extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get clientId(): string {
    return this.get(KEYS.CLIENT_ID);
  }

  get name(): string {
    return this.get(KEYS.NAME);
  }
}
